const { default: Swiper } = require('swiper');
const { Autoplay } = require('swiper/modules');

const sections = document.querySelectorAll('section.tab-section');

const syncSlideImages = (slidesImages, activeIndex) => {
    slidesImages.forEach((slide, index) => {
        if (index === activeIndex) {
            setTimeout(() => {
                slide.classList.add('active');
            }, 300);
        } else {
            slide.classList.remove('active');
        }
    });
};

if (sections.length) {
    sections.forEach(section => {
        const slider = section.querySelector('.slider');
        if (slider) {
            const slidesImages = section.querySelectorAll('[data-slide-image]');
            const swiper = new Swiper(slider, {
                direction: 'vertical',
                allowTouchMove: false,
                simulateTouch: false,
                preventClicks: false,
                preventClicksPropagation: false,
                slideActiveClass: 'active',
                modules: [Autoplay],
                autoplay: {
                    disableOnInteraction: false,
                    waitForTransition: false,
                    delay: 6000,
                },
            });

            swiper.on('slideChange', ({ activeIndex }) => {
                syncSlideImages(slidesImages, activeIndex);
            });

            slider.addEventListener('click', event => {
                const slide = event.target.closest('.swiper-slide');

                if (!slide || !slider.contains(slide)) {
                    return;
                }

                const slides = [...slider.querySelectorAll('.swiper-slide')];
                const index = slides.indexOf(slide);

                if (index === -1 || index === swiper.activeIndex) {
                    return;
                }

                swiper.slideTo(index);

                if (swiper.autoplay?.running) {
                    swiper.autoplay.stop();
                    swiper.autoplay.start();
                }
            });
        }
    });
}
